import { render } from "./detalCard.vue?vue&type=template&id=b9a27c46&scoped=true"
import script from "./detalCard.vue?vue&type=script&lang=js"
export * from "./detalCard.vue?vue&type=script&lang=js"

import "./detalCard.vue?vue&type=style&index=0&id=b9a27c46&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a27c46"]])

export default __exports__